import { Negotiation } from '@/modules/negotiation/entities/interfaces/negotiation';
import { MOCK_CONTRACT } from './mockContract';
import { MOCK_COST_CENTER } from './mockCostCenter';
import { MOCK_PRODUCT } from './mockProduct';

export const MOCK_NEGOTIATION: Negotiation = {
  id: '3e0250ce-a009-452d-b492-931b89632530',
  createdAt: '2023-05-01T12:00:00Z',
  updatedAt: '2023-05-02T10:30:00Z',
  deletedAt: null,
  deletionReason: null,
  contract: MOCK_CONTRACT,
  costCenter: MOCK_COST_CENTER,
  product: MOCK_PRODUCT,
  brokerId: '522c7c44-df4d-492e-809a-8a81f0aedc7e',
  contractId: '30464e47-17e1-4d6b-999e-3b92a2a45036',
  costCenterId: 'ab83a029-aef6-4aae-a3ed-548a8b06fa7d',
  productId: '01eb4c99-162c-455a-b610-9fc4aeb0493e',
  markups: [],
  reimbursement: 0,
};
